import React, { createContext, FC, useContext } from "react";
import { useCheckout } from "~hooks";

const CheckoutContext = createContext<
  ReturnType<typeof useCheckout> | undefined
>(undefined);

export const CheckoutProvider: FC = ({ children }) => {
  const checkout = useCheckout({});
  return (
    <CheckoutContext.Provider value={checkout}>
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckoutContext = () => {
  const ctx = useContext(CheckoutContext);
  if (!ctx) throw new Error("useCheckout must be used within CheckoutProvider");
  return ctx;
};
